import { apiSetProfile } from 'app/api_v2/inspectors/profile';
import { setInspectorProfileId } from 'app/store/auth';
import { RootState } from 'app/store/rootReducer';
import DataLoader from 'app/ui_v2/components/data-loader/DataLoader';
import ErrorsList from 'app/ui_v2/components/errors-list/ErrorsList';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { Box } from '@mui/material';
import { useMutation } from '@tanstack/react-query';

export default function InspectorAddProfile() {
  const { user } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();

  const mutation = useMutation({
    mutationFn: () => apiSetProfile(),
    onSuccess: (data: string) => {
      dispatch(setInspectorProfileId(data));
    },
  });

  if (!user) {
    console.error('No user exists');
    return <Navigate to={`/agency/dashboard`} />;
  }

  if (!mutation.isLoading && !mutation.isError && !mutation.isSuccess && !Boolean(user.inspectorProfile?.id)) {
    mutation.mutate();
  }

  if (user.inspectorProfile?.id) {
    return <Navigate to={`/agency/inspector/${user.inspectorProfile?.id}/main`} />;
  }

  return (
    <>
      <Box mt={3}>
        {!mutation.isError && <DataLoader />}
        {mutation.isError && mutation.error && (
          <ErrorsList title="Unexpected error" errors={mutation.error as string[]} />
        )}
      </Box>
    </>
  );
}
